'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dGrouping$002dDescription$0024$0024anon$002441 from "./presto.types$-Grouping-Description$$anon$41.js";
import * as $j_presto$002etypes$0024$002dGrouping$002dDescription$0024$0024anon$002442 from "./presto.types$-Grouping-Description$$anon$42.js";
var $p;
/** @constructor */
function $c_Lpresto_types$GroupingDescription$() {
  this.c6A = null;
  this.c6B = false;
  this.c6y = null;
  this.c6z = false;
  this.c6E = null;
  this.c6F = false;
  this.c6C = null;
  this.c6D = false;
  this.c6G = null;
  this.c6H = false;
}
export { $c_Lpresto_types$GroupingDescription$ as $c_Lpresto_types$GroupingDescription$ };
$p = $c_Lpresto_types$GroupingDescription$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$GroupingDescription$;
/** @constructor */
function $h_Lpresto_types$GroupingDescription$() {
}
export { $h_Lpresto_types$GroupingDescription$ as $h_Lpresto_types$GroupingDescription$ };
$h_Lpresto_types$GroupingDescription$.prototype = $p;
$p.cHx = (function() {
  if ((!this.c6B)) {
    this.c6A = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.c6B = true;
  }
  return this.c6A;
});
$p.p3 = (function() {
  if ((!this.c6z)) {
    this.c6y = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a8;
    this.c6z = true;
  }
  return this.c6y;
});
$p.cIc = (function() {
  if ((!this.c6F)) {
    this.c6E = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.c6F = true;
  }
  return this.c6E;
});
$p.cHX = (function() {
  if ((!this.c6D)) {
    this.c6C = new $j_presto$002etypes$0024$002dGrouping$002dDescription$0024$0024anon$002441.$c_Lpresto_types$GroupingDescription$$anon$41(this);
    this.c6D = true;
  }
  return this.c6C;
});
$p.cIu = (function() {
  if ((!this.c6H)) {
    this.c6G = new $j_presto$002etypes$0024$002dGrouping$002dDescription$0024$0024anon$002442.$c_Lpresto_types$GroupingDescription$$anon$42(this);
    this.c6H = true;
  }
  return this.c6G;
});
var $d_Lpresto_types$GroupingDescription$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$GroupingDescription$, "presto.types$GroupingDescription$", ({
  a0C: 1,
  D: 1
}));
export { $d_Lpresto_types$GroupingDescription$ as $d_Lpresto_types$GroupingDescription$ };
var $n_Lpresto_types$GroupingDescription$;
function $m_Lpresto_types$GroupingDescription$() {
  if ((!$n_Lpresto_types$GroupingDescription$)) {
    $n_Lpresto_types$GroupingDescription$ = new $c_Lpresto_types$GroupingDescription$();
  }
  return $n_Lpresto_types$GroupingDescription$;
}
export { $m_Lpresto_types$GroupingDescription$ as $m_Lpresto_types$GroupingDescription$ };
//# sourceMappingURL=presto.types$-Grouping-Description$.js.map
